export function getOptions(data: any[], valueKey: string, labelKey?: string) {
  if (!data || data.length === 0) return [];

  const get = (obj: any, path: string) =>
    path.includes('.') ? path.split('.').reduce((o, k) => o?.[k], obj) : obj[path];

  const options = new Map();

  data.forEach(item => {
    const value = get(item, valueKey);
    if (value == null || value === '') return;

    if (!options.has(value)) {
      const label = labelKey ? get(item, labelKey) ?? value : value;
      if (label != null && label !== '') {
        options.set(value, {
          value: String(value),
          label: String(label),
        });
      }
    }
  });

  return Array.from(options.values()).sort((a, b) => a.value.localeCompare(b.value));
}
